import Color from '../Color.mjs'
import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_BLUE,
    type: 'MDM',
    name: 'MD知识模件',
    textProp: 'moduleName',
    codeProp: 'moduleCode',
    detailUrl: '/MdModuleDetail',
    detailIdProp: 'pkid',
    listUrl: '/MdList',
    mapProp: '',
}
